// Families per directory page. The directory shows ten; an embed may ask for
// another size and offer the reader a choice. Kept import-free so both the
// reducer and the pure list shaping can read it without a cycle.
export const DIRECTORY_PAGE_SIZE = 10
